import { NumberLineQuestion } from '~/types/bootcamp'

import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

import { NumberLineActivityData } from './NumberLine.type'

/**
 * Chooses question for the activity
 * @param questions all available number line questions
 * @param history previously selected question history
 * @returns number line activity data
 */
export function generateNumberLineActivityData(
  questions: NumberLineQuestion[],
  history: number[],
): NumberLineActivityData {
  const questionIndex = getRandomInt(0, questions.length - 1, history)
  const question = questions[questionIndex]

  return { questionIndex, question }
}
